import { render, staticRenderFns } from "./CameraMechanics.vue?vue&type=template&id=36105932&scoped=true&"
import script from "./CameraMechanics.vue?vue&type=script&lang=js&"
export * from "./CameraMechanics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36105932",
  null
  
)

export default component.exports